import styled from 'styled-components';

const TextStepContainer = styled.div`
  align-items: flex-end !important;
  display: flex !important;
  justify-content: ${props => props.user ? 'flex-end' : 'flex-start'} !important;
`;

export default TextStepContainer;
